module.exports = __webpack_public_path__ + "img/management-cta.7645f2b5.svg";